import { HasIdAndName } from "@homebound/beam";
import { ItivOrderField } from "src/generated/graphqlTypes";

export function offeringItemTableGroupByOptions(): HasIdAndName[] {
  return [
    { id: ItivOrderField.Options, name: "Option" },
    { id: ItivOrderField.CostCode, name: "Cost Code" },
    { id: ItivOrderField.CostDivision, name: "Cost Division" },
    { id: ItivOrderField.LocationLevel, name: "Level" },
    { id: ItivOrderField.LocationRoom, name: "Room" },
    { id: ItivOrderField.LocationFeature, name: "Feature" },
  ];
}

export function offeringItemTableSortByOptions(): HasIdAndName[] {
  return [
    { id: ItivOrderField.Item, name: "Item code" },
    { id: ItivOrderField.MaterialCode, name: "Material Code" },
    { id: ItivOrderField.Location, name: "Location" },
  ];
}

/** Label for a preferred BCLI that is intentionally $0 or a missing-cost placeholder. */
export function bcliCostLabel(
  bcli: { isNoCost?: boolean | null; isMissingCost?: boolean | null } | null | undefined,
): string | undefined {
  if (bcli?.isNoCost) return "No Cost";
  if (bcli?.isMissingCost) return "Missing Cost";
  return undefined;
}
